module.exports = __webpack_public_path__ + "static/media/pw-logo.98ff26f5.png";